import { render, staticRenderFns } from "./tiendas.vue?vue&type=template&id=da4a9606&"
import script from "./tiendas.vue?vue&type=script&lang=js&"
export * from "./tiendas.vue?vue&type=script&lang=js&"
import style0 from "./tiendas.vue?vue&type=style&index=0&id=da4a9606&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports